import * as moment from 'moment';
import { IDonorDeclines, IFwtSummary, IMortalityCalculations, IRecipient } from '@nkr/models/index';
import { DeclineRatio } from './decline-ratio-type';

const start = moment().subtract(3, 'months').format('YYYY-MM-DD');
const end = moment().format('YYYY-MM-DD');

interface IMortalityBreakdown {
    show: boolean,
    recipientAlias: string,
    data: IMortalityCalculations
}

interface IFwt {
    show: boolean,
    fwtSummary: IFwtSummary
}

interface IState {
    donorDeclineData: IDonorDeclines[],
    recipient: IRecipient,
    declineRatioAllTime: number,
    startDate: string,
    endDate: string
    declineRatioType: DeclineRatio,
    declineRatioAdjusted: number,
    mortalityBreakdown: IMortalityBreakdown,
    fwt: IFwt
}

const initialState: IState = {
    donorDeclineData: [],
    recipient: null,
    declineRatioAllTime: 0,
    startDate: start,
    endDate: end,
    declineRatioType: DeclineRatio.Current,
    declineRatioAdjusted: 0,
    mortalityBreakdown: {
        show: false,
        recipientAlias: '',
        data: null
    },
    fwt: {
        show: false,
        fwtSummary: null
    }
};

type Action =
    | { type: 'afterLoad', payload: { donorDeclineData: IDonorDeclines[], recipient: IRecipient, declineRatioAllTime: number } }
    | { type: 'changeStartDate', payload: string }
    | { type: 'changeEndDate', payload: string }
    | { type: 'changeDeclineRatioType', payload: DeclineRatio }
    | { type: 'changeDeclineRatioAdjusted', payload: number }
    | { type: 'updateMortalityRiskCal', payload: IMortalityBreakdown }
    | { type: 'updateFWTCal', payload: IFwt }
    ;

const donorDeclinesReducer = (state: IState, action: Action): IState => {
    if (action.type == 'afterLoad') {
        return {
            ...state,
            donorDeclineData: action.payload.donorDeclineData,
            recipient: action.payload.recipient,
            declineRatioAllTime: action.payload.declineRatioAllTime,
        };
    }

    if (action.type == 'changeStartDate') {
        return {
            ...state,
            startDate: action.payload,
        }
    }

    if (action.type == 'changeEndDate') {
        return {
            ...state,
            endDate: action.payload,
        }
    }

    if (action.type == 'changeDeclineRatioType') {
        return {
            ...state,
            declineRatioType: action.payload,
        }
    }

    // if (action.type == 'sortedDataChange') {
    //     return {
    //         ...state,
    //         sortedDonorDeclinesData: action.value
    //     }
    // }

    if (action.type == 'changeDeclineRatioAdjusted') {
        return {
            ...state,
            declineRatioAdjusted: action.payload
        }
    }

    if (action.type == 'updateMortalityRiskCal') {
        return {
            ...state,
            mortalityBreakdown: action.payload
        }
    }

    if (action.type == 'updateFWTCal') {
        return {
            ...state,
            fwt: action.payload
        }
    }

    return { ...state };
};

export {
    IState, initialState,
    donorDeclinesReducer
};